var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 3.00004V1.00004C2.66667 0.82323 2.7369 0.65366 2.86193 0.528636C2.98695 0.403612 3.15652 0.333374 3.33333 0.333374H11.3333C11.5101 0.333374 11.6797 0.403612 11.8047 0.528636C11.9298 0.65366 12 0.82323 12 1.00004V10.3334C12 10.5102 11.9298 10.6798 11.8047 10.8048C11.6797 10.9298 11.5101 11 11.3333 11H9.33333V13C9.33333 13.368 9.03333 13.6667 8.662 13.6667H0.671333C0.583418 13.6672 0.496265 13.6504 0.414882 13.6171C0.333498 13.5839 0.259489 13.5349 0.197106 13.4729C0.134723 13.411 0.0851953 13.3373 0.0513695 13.2561C0.0175437 13.175 8.62495e-05 13.088 0 13L0.00200001 3.66671C0.00200001 3.29871 0.302 3.00004 0.673334 3.00004H2.66667ZM1.33533 4.33337L1.33333 12.3334H8V4.33337H1.33533ZM4 3.00004H9.33333V9.66671H10.6667V1.66671H4V3.00004Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.2ee6d939d7e1afd592ba0a20b27dc1af.svg";
export { ForwardRef as ReactComponent };